module.exports = __webpack_public_path__ + "static/media/6Rectangle.d04188a9.jpeg";